import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomFieldsIndex } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchInterviewCustomFields() {
  return useQuery({
    queryKey: ['candidateInterviewLogs'],
    queryFn: async () => {
      const data = await fetchJson<AgentApiCustomFieldsIndex>(
        `/agent/api/candidate_profiles/interview_custom_fields.json`
      );

      return data;
    },
  });
}
